export default {
  created () {
    this.singleActions = []
  },
}
